import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import roomDisplay from '../room-display/store'
import roomRateDisplay from '../room-rate-display/store'
import multiRoomDisplay from '../multi-room-display/store'

export { state, mutations, getters, actions }

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    roomDisplay,
    roomRateDisplay,
    multiRoomDisplay
  },
  state,
  mutations,
  getters,
  actions
})
